var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("el-row", { staticClass: "filter" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "95%",
              margin: "0 auto",
              "padding-top": "5px"
            }
          },
          [
            _c("span", [_vm._v("商家信息")]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { float: "right" },
                attrs: { type: "success", size: "mini" },
                on: { click: _vm.updateSupply }
              },
              [_vm._v("编辑")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("p", {
          staticStyle: { width: "100%", "border-bottom": "solid 1px #e0e0e0" }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { width: "95%", margin: "0 auto", color: "gray" } },
          [
            _vm.resData.profile
              ? _c("div", { staticStyle: { float: "left", width: "33%" } }, [
                  _c("p", [
                    _c("label", [_vm._v("商家名称：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.resData.profile.supply_name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("城市：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.resData.profile.supply_city))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("市场：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.resData.profile.father_market))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("子市场：")]),
                    _c("span", [_vm._v(_vm._s(_vm.resData.profile.market))])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("楼层：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.resData.profile.supply_floor))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("区域/街 ：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.resData.profile.supply_area))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("档口号：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.resData.profile.supplier_num))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("品牌：")]),
                    _c("span", [_vm._v(_vm._s(_vm.resData.profile.brands))])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("联系方式：")]),
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.handleGetPrivateInfo(
                              "supply_mobile_phone"
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.resData.profile.supply_mobile_phone))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("微信昵称：")]),
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.handleGetPrivateInfo("supply_wechat")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.resData.profile.supply_wechat))]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.resData.profile
              ? _c("div", { staticStyle: { float: "left", width: "33%" } }, [
                  _c(
                    "div",
                    { staticStyle: { width: "100%", float: "left" } },
                    [
                      _c("p", { staticStyle: { float: "left" } }, [
                        _c("label", [_vm._v("收款人信息 ：")])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.resData.profile.payees, function(
                        payee,
                        index
                      ) {
                        return _c(
                          "p",
                          {
                            key: index,
                            on: {
                              click: function($event) {
                                return _vm.handleGetPrivateInfo("payees")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(payee.payee_name) +
                                "-" +
                                _vm._s(payee.payee_bank) +
                                "-" +
                                _vm._s(payee.payee_bank_account) +
                                "\n          "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("是否可刷单：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.resData.profile.supply_is_scal))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("商家状态：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.resData.profile.supply_supply_status))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("绑定代采组：")]),
                    _c("span", [_vm._v(_vm._s(_vm.resData.profile.pgname))])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("买手组：")]),
                    _c("span", [_vm._v(_vm._s(_vm.resData.profile.pg_name))])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("代采员：")]),
                    _c("span", [_vm._v(_vm._s(_vm.resData.profile.mbmber))])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("锁定排单天数：")]),
                    _c("span", [_vm._v(_vm._s(_vm.resData.profile.limit_day))])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("是否实力档口：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.resData.profile.supply_is_strength))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("擅长季节：")]),
                    _c("span", [_vm._v(_vm._s(_vm.resData.profile.season))])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("擅长品类：")]),
                    _c("span", [_vm._v(_vm._s(_vm.resData.profile.cats))])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.resData.profile
              ? _c("div", { staticStyle: { float: "left", width: "33%" } }, [
                  _c("p", [
                    _c("label", [_vm._v("主要风格：")]),
                    _c("span", [_vm._v(_vm._s(_vm.resData.profile.styles))])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("适应年龄段：")]),
                    _c("span", [_vm._v(_vm._s(_vm.resData.profile.age_group))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticStyle: { float: "left", width: "20%" } },
                    [_vm._v("档口图片：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [{ name: "viewer", rawName: "v-viewer" }],
                      staticStyle: {
                        width: "80%",
                        overflow: "hidden",
                        cursor: "pointer",
                        margin: "auto",
                        float: "left",
                        height: "44px"
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "40px", height: "40px" },
                        attrs: { src: _vm.resData.profile.pic, alt: "" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticStyle: { float: "left", width: "20%" } },
                    [_vm._v("营业执照：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [{ name: "viewer", rawName: "v-viewer" }],
                      staticStyle: {
                        width: "80%",
                        overflow: "hidden",
                        cursor: "pointer",
                        margin: "auto",
                        float: "left",
                        height: "44px"
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "44px", height: "44px" },
                        attrs: { src: _vm.resData.profile.license, alt: "" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticStyle: { float: "left", width: "20%" } },
                    [_vm._v("档口头像：")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [{ name: "viewer", rawName: "v-viewer" }],
                      staticStyle: {
                        width: "80%",
                        overflow: "hidden",
                        cursor: "pointer",
                        margin: "auto",
                        float: "left",
                        height: "44px"
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "44px", height: "44px" },
                        attrs: { src: _vm.resData.profile.avatar, alt: "" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("档口优点：")]),
                    _c("span", [_vm._v(_vm._s(_vm.resData.profile.advantage))])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("档口缺点：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.resData.profile.disadvantage))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("商家地址：")]),
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.handleGetPrivateInfo("supply_address")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.resData.profile.supply_address))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [_vm._v("爆版余额：")]),
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.handleGetPrivateInfo("supply_balance")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.resData.profile.supply_balance))]
                    )
                  ])
                ])
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c("SupplyFulfillDetail", { attrs: { "supply-id": _vm.supplyId } }),
      _vm._v(" "),
      _c("el-row", { staticClass: "filter" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "95%",
              margin: "0 auto",
              "padding-top": "5px"
            }
          },
          [_c("span", [_vm._v("数据标签")])]
        ),
        _vm._v(" "),
        _c("p", {
          staticStyle: { width: "100%", "border-bottom": "solid 1px #e0e0e0" }
        }),
        _vm._v(" "),
        _vm.resData.portrait
          ? _c(
              "div",
              {
                staticStyle: { width: "95%", margin: "0 auto", color: "gray" }
              },
              [
                _c("div", { staticStyle: { float: "left", width: "33%" } }, [
                  _c(
                    "p",
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "用户申请无理由退换件数/发货件数",
                            placement: "top-start"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-info" })]
                      ),
                      _vm._v(" "),
                      _c("label", [_vm._v("无理由退换率：")]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.resData.portrait.noreason_rates))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content:
                              "剔除掉商品异常和物流问题的工单件数/发货件数",
                            placement: "top-start"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-info" })]
                      ),
                      _vm._v(" "),
                      _c("label", [_vm._v("工单率：")]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.resData.portrait.problem_rates))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "质量平均分",
                            placement: "top-start"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-info" })]
                      ),
                      _vm._v(" "),
                      _c("label", [_vm._v("商品质量评分：")]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.resData.portrait.ave_quality_va))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "性价比&质量&热卖的平均分",
                            placement: "top-start"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-info" })]
                      ),
                      _vm._v(" "),
                      _c("label", [_vm._v("商品满意度：")]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.resData.portrait.avergesocre_va))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "用户申请质量问题件数/发货件数",
                            placement: "top-start"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-info" })]
                      ),
                      _vm._v(" "),
                      _c("label", [_vm._v("次品率：")]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.resData.portrait.service_rates))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.resData.portrait
                  ? _c(
                      "div",
                      { staticStyle: { float: "left", width: "33%" } },
                      [
                        _c(
                          "p",
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content:
                                    "成交 GMV（[300000,+):极高、[80000,300000)：高、[50000,80000)：一般、[0,50000)：低）",
                                  placement: "top-start"
                                }
                              },
                              [_c("i", { staticClass: "el-icon-info" })]
                            ),
                            _vm._v(" "),
                            _c("label", [_vm._v("月均拿货水平：")]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.resData.portrait.amount) +
                                  "(" +
                                  _vm._s(_vm.resData.portrait.amount_range) +
                                  ")"
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content:
                                    "商品2次（含）以上购买的用户数/购买用户数（[15%,+)：极高、[11%，15%)：高、[8%,11%)：一般、[0,8%)：低、用户数<100：不计）",
                                  placement: "top-start"
                                }
                              },
                              [_c("i", { staticClass: "el-icon-info" })]
                            ),
                            _vm._v(" "),
                            _c("label", [_vm._v("复购率水平：")]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.resData.portrait.fg_user_rates) +
                                  "(" +
                                  _vm._s(_vm.resData.portrait.fg_rates_range) +
                                  ")"
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content:
                                    "成交件数>=30件的款数占比（[30%,+)达标）",
                                  placement: "top-start"
                                }
                              },
                              [_c("i", { staticClass: "el-icon-info" })]
                            ),
                            _vm._v(" "),
                            _c("label", [_vm._v("整体销售水平：")]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.resData.portrait.whole_rates) +
                                  "(" +
                                  _vm._s(
                                    _vm.resData.portrait.whole_rates_range
                                  ) +
                                  ")"
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content:
                                    "成交件数>=70件的款数占比（[8%,+)达标）",
                                  placement: "top-start"
                                }
                              },
                              [_c("i", { staticClass: "el-icon-info" })]
                            ),
                            _vm._v(" "),
                            _c("label", [_vm._v("爆款水平：")]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.resData.portrait.hot_rates) +
                                  "(" +
                                  _vm._s(_vm.resData.portrait.hot_rates_range) +
                                  ")"
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content:
                                    "成交件数>=5件的款数占比（[8%,+)达标）",
                                  placement: "top-start"
                                }
                              },
                              [_c("i", { staticClass: "el-icon-info" })]
                            ),
                            _vm._v(" "),
                            _c("label", [_vm._v("成团率水平：")]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.resData.portrait.engough_rates) +
                                  "(" +
                                  _vm._s(
                                    _vm.resData.portrait.engough_rates_range
                                  ) +
                                  ")"
                              )
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.resData.portrait
                  ? _c(
                      "div",
                      { staticStyle: { float: "left", width: "33%" } },
                      [
                        _c(
                          "p",
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "第一次商品上架的专场时间",
                                  placement: "top-start"
                                }
                              },
                              [_c("i", { staticClass: "el-icon-info" })]
                            ),
                            _vm._v(" "),
                            _c("label", [_vm._v("首次合作日期：")]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.resData.portrait.cop_time))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "最近一次商品上架的专场时间",
                                  placement: "top-start"
                                }
                              },
                              [_c("i", { staticClass: "el-icon-info" })]
                            ),
                            _vm._v(" "),
                            _c("label", [_vm._v("上次合作日期：")]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.resData.portrait.last_time))
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.resData
        ? _c(
            "el-row",
            { staticClass: "filter" },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    width: "95%",
                    margin: "0 auto",
                    "padding-top": "5px"
                  }
                },
                [
                  _c("span", [_vm._v("商家代采报表")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { float: "right" },
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.wcg_order_detail }
                    },
                    [_vm._v("查看明细")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("p", {
                staticStyle: {
                  width: "100%",
                  "border-bottom": "solid 1px #e0e0e0"
                }
              }),
              _vm._v(" "),
              _c(
                "el-col",
                [
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          border: "",
                          data: _vm.resData.wcg_order,
                          "tooltip-effect": "dark"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "all_num",
                            label: "实际报单"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "num",
                            label: "已入库",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "rj_owe_num",
                            label: "退换欠货",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "owe_num",
                            label: "代采欠货",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ded_num",
                            label: "转抵扣",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "refund_num",
                            label: "已退款",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "baddebt_num",
                            label: "呆账",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "broken_num",
                            label: "坏账",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "95%",
                margin: "0 auto",
                "padding-top": "5px"
              }
            },
            [
              _c(
                "span",
                [
                  _vm._v("代采履约情况\n        "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "dark", placement: "top-start" }
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v(
                            "\n            以下均为推前7天算起的" +
                              _vm._s(_vm.portrait_data_value) +
                              "天内的统计数据"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            开单率：实际开单的代采订单商品数量/计划代采的商品数量"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            回货率：实际入库的商品数量/代采订单的商品数量"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            配货率：实际配货的商品数量/应配的商品数量（剔除不成团、主动取消的商品）"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            实发率：实际发出的商品数量/应配的商品数量（剔除不成团、主动取消的商品）"
                          ),
                          _c("br")
                        ]
                      ),
                      _vm._v(" "),
                      _c("i", { staticClass: "el-icon-info" })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.setData(7)
                        }
                      }
                    },
                    [_vm._v("7天")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.setData(15)
                        }
                      }
                    },
                    [_vm._v("15天")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.setData(30)
                        }
                      }
                    },
                    [_vm._v("30天")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.setData(90)
                        }
                      }
                    },
                    [_vm._v("90天")]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("p", {
            staticStyle: { width: "100%", "border-bottom": "solid 1px #e0e0e0" }
          }),
          _vm._v(" "),
          _c(
            "el-col",
            [
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.tableLoading,
                        expression: "tableLoading"
                      }
                    ],
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      border: "",
                      data: _vm.portrait_data,
                      "tooltip-effect": "dark"
                    }
                  },
                  [
                    _c(
                      "el-table-column",
                      { attrs: { align: "center", label: "开单率" } },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "24_billing_rates",
                            label: "24小时",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "48_billing_rates",
                            label: "48小时",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "end_billing_rates",
                            label: "最终",
                            align: "center"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          label: "回货率",
                          "show-overflow-tooltip": "",
                          align: "center"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "24_stock_rates",
                            label: "24小时",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "48_stock_rates",
                            label: "48小时",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "end_stock_rates",
                            label: "最终",
                            align: "center"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          label: "配货率",
                          "show-overflow-tooltip": "",
                          align: "center"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "24_allot_rates",
                            label: "24小时",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "48_allot_rates",
                            label: "48小时",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "end_allot_rates",
                            label: "最终",
                            align: "center"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          label: "实发率",
                          "show-overflow-tooltip": "",
                          align: "center"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "24_ship_rates",
                            label: "24小时",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "48_ship_rates",
                            label: "48小时",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "end_ship_rates",
                            label: "最终",
                            align: "center"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c_page-title" }, [
      _c("div", [_vm._v("商家画像")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78096f6d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78096f6d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supply/Profile.vue
// module id = null
// module chunks = 